
const linkProcessing = link => {
  const arr = ['http', 'https', 'ftp', 'file', 'www'];
  const h = `${window.clientProtocol}//`;
  let indexOfLink = 0;

  for (let ii = 0; ii < arr.length; ii++) {
    if (~link.indexOf(arr[ii])) {
      indexOfLink = link.indexOf(arr[ii]);
      break;
    }
  }

  const text = link.substr(indexOfLink);
  const src = text.match(/http:\/\/|https:\/\//gi) ? text.replace(/&nbsp;|\s/gi, '') : h + text;

  return {
    before: link.substr(0, indexOfLink),
    src,
    text,
  };
};

const findLinkOrEmail = (text, regLink) => {
  let subtype = null;
  const links = [];
  if (!text) return { text, subtype, links }

  const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let nestingTagA = 0;
  let delimitedText = text.replace(/[>,，【】\t\n\s\v\r\u00a0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000]/g, '$&\f');
  delimitedText = delimitedText.replace(/[<,，【】\t\n\s\v\r\u00a0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000]/g, '\f$&');
  let partsOfText = delimitedText.split(/\f/);

  for (let i = 0; i < partsOfText.length; i++) {
    /* if the "a" tag is open */
    if (~partsOfText[i].indexOf('<a')) nestingTagA++;
    if (~partsOfText[i].indexOf('</a>')) {
      nestingTagA--;
      continue;
    }
    if (nestingTagA) continue;

    /* if it's email */
    if ((partsOfText[i].replace(/mailto:/gi, '').match(regEmail)) && (!partsOfText[i].match(/src|href/gi))) {
      partsOfText[i] = partsOfText[i].match(/mailto:/gi)
        ? `mailto:<a href="${partsOfText[i]}" target="_blank" rel="noopener noreferrer"/>${partsOfText[i].replace(/mailto:/gi, '')}</a>`
        : `<a href="mailto:${partsOfText[i]}" target="_blank" rel="noopener noreferrer"/>${partsOfText[i]}</a>`;

      subtype = 'link';
      continue;
    }

    /* if it's link */
    if ((partsOfText[i].match(regLink)) && (!partsOfText[i].match(/src|href/gi))) {
      let link = linkProcessing(partsOfText[i]);
      links.push(link.src);
      partsOfText[i] = (link.before.length > 0 ? link.before : '');
      partsOfText[i] += `<a href="${link.src}" target="_blank" rel="noopener noreferrer"/>${link.text}</a>`;

      subtype = 'link';
    }
  }

  return { text: partsOfText.join(''), subtype, links };
};

export default findLinkOrEmail;
